import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const ErrorText = styled(Typography)`
  color: ${({ theme }) => theme.colors.error900};
`;

export default ErrorText;
